module.exports = __webpack_public_path__ + "img/logographiko.5ac94673.png";